import React from "react";
import "./support.scss";
import { Element } from "react-scroll";
import { Link } from "react-scroll";
import { NavLink } from "react-router-dom";
import { Accordion } from "react-bootstrap";

const Chatandpayment = () => {
  return (
    <>
      <div className="maincontent">
        <div className="innercontent">
          <div>
            <h1 className="mainhead">Chat and Payments</h1>

            <Accordion defaultActiveKey="0">
              <Element name="sendcryptoviachat">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Send crypto via Chat</Accordion.Header>
                  <Accordion.Body>
                    <p className="accpara">
                      To send crypto to a friend directly through the tomi app
                      chat, perform the following steps:
                    </p>
                    <ol>
                      <li>
                        Open the chat with the person you want to send crypto
                        to. Tap the <strong>Send $</strong> button at the top
                        right or the <strong>$</strong> button at the bottom
                        right of the chat screen.
                      </li>
                      <li>
                        If your wallet does not have sufficient funds, you will
                        be prompted to add crypto to your wallet. Follow the
                        instructions on the screen to add funds before
                        proceeding.
                      </li>
                      <li>
                        If you have funds but no ETH for gas fees (required for
                        Ethereum-based transactions), tap{" "}
                        <strong>Add Ether</strong> on the{" "}
                        <strong>Add ETH to proceed</strong> screen. Once you’ve
                        added ETH, return to the chat.
                      </li>
                      <li>
                        After ensuring your wallet is ready, select the
                        cryptocurrency you want to send from the list displayed
                        (e.g., TOMI or Ethereum). The app will show your
                        available balance for each token.
                      </li>
                      <li>
                        Enter the amount of crypto (or equivalent amount in USD)
                        you wish to send in the input field. The app will
                        display an estimated fee and total transaction cost
                        below the input field.
                      </li>
                      <li>
                        Tap <strong>Send</strong>, and a confirmation screen
                        will appear showing:
                      </li>
                      <ul>
                        <li>The amount being sent</li>
                        <li>The recipient’s username</li>
                        <li>The estimated fee and total cost</li>
                      </ul>
                      <li>
                        Slide the bar at the bottom of the confirmation screen
                        to complete the transaction.
                      </li>
                      <li>
                        If biometric authentication is enabled, verify your
                        identity using Face ID or your fingerprint. Otherwise,
                        enter your PIN code.
                      </li>
                      <li>
                        The intended recipient will receive a notification and
                        can choose to accept or decline the payment. Until they
                        respond one way or the other, the payment transaction is
                        pending on your end.
                      </li>
                      <li>
                        If the recipient accepts the payment, you will be
                        notified that you can proceed with sending the payment.
                      </li>
                      <li>
                        Once the payment is sent, a confirmation message appears
                        for both sides to see directly in the chat and the
                        recipient will receive the funds.
                      </li>
                    </ol>
                  </Accordion.Body>
                </Accordion.Item>
              </Element>
              <Element name="requestpaymentsinchat">
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Request payments in Chat</Accordion.Header>
                  <Accordion.Body>
                    <p className="accpara">
                      The tomi app allows you to request cryptocurrency payments
                      directly through chat. This feature is perfect for
                      splitting bills, requesting reimbursements, or simply
                      asking for funds from friends or contacts. The recipient
                      will see your request and can proceed to send the payment
                      with all details pre-filled for a seamless transaction.
                    </p>
                    <p className="accpara">
                      To request a payment in chat, follow these steps:
                    </p>
                    <ol>
                      <li>
                        Open the chat with the person you want to request
                        payment from.
                      </li>
                      <li>
                        Tap the <strong>$</strong> button at the bottom right of
                        the chat screen.
                      </li>
                      <li>
                        In the pop-up menu, select{" "}
                        <strong>Request Payment</strong>.
                      </li>
                      <li>
                        Choose the cryptocurrency you want to request from the
                        list displayed (e.g., Bitcoin, TOMI, Ethereum).
                      </li>
                      <li>
                        In the input field, enter the crypto or fiat amount you
                        wish to request.
                      </li>
                      <li>
                        Add an optional note or description for the payment
                        request (e.g., "Dinner split" or "Rent contribution").
                      </li>
                      <li>
                        Tap <strong>Request</strong>, and your payment request
                        will be sent to the recipient.
                      </li>
                    </ol>
                    <p className="accpara">
                      <strong>What Happens Next?</strong>
                    </p>
                    <ul>
                      <li>
                        The recipient will receive a notification and see your
                        payment request in the chat.
                      </li>
                      <li>
                        If they have sufficient funds, they can accept your
                        request and proceed to the <strong>Send Crypto</strong>{" "}
                        screen.
                      </li>
                      <li>
                        All transaction details (amount, cryptocurrency type,
                        and recipient) will be pre-filled for their
                        confirmation.
                      </li>
                      <li>
                        Once they confirm and complete the transaction, the
                        requested cryptocurrency will be transferred to your
                        wallet.
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Element>
              <Element name="receivepaymentsinchat">
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Receive payments in Chat (without a request)
                  </Accordion.Header>
                  <Accordion.Body>
                    <p className="accpara">
                      The tomi app ensures secure and controlled transactions
                      when receiving cryptocurrency payments through chat. If a
                      sender attempts to send funds without a prior request,
                      you’ll have the option to accept or decline the payment.
                      The transaction proceeds only with your approval, giving
                      you full control over incoming payments.
                    </p>
                    <p className="accpara">
                      <strong>How it works</strong>
                    </p>
                    <ol>
                      <li>
                        When a sender attempts to send cryptocurrency without an
                        existing payment request, you will receive a
                        notification in the chat asking for your approval.
                      </li>
                      <li>Review the payment details, including:</li>
                      <ul>
                        <li>The amount of cryptocurrency.</li>
                        <li>
                          The type of cryptocurrency (e.g., Bitcoin, TOMI,
                          Ethereum).
                        </li>
                        <li>The sender’s username.</li>
                      </ul>
                      <li>
                        Tap <strong>Accept</strong> if you wish to proceed with
                        the transaction. This will allow the sender to complete
                        the payment.
                      </li>
                      <li>
                        If you do not wish to receive the funds, tap{" "}
                        <strong>Decline</strong>. The sender will not be able to
                        proceed with the transaction unless you initiate a new
                        request.
                      </li>
                      <li>
                        Once you accept and the sender completes the
                        transaction, the cryptocurrency will be transferred
                        directly to your wallet. You’ll see a confirmation
                        message in the chat indicating that the payment was
                        successful.
                      </li>
                    </ol>
                    <p className="accpara">
                      This process ensures that all incoming payments are
                      authorized by you, providing an added layer of security
                      and control over your transactions.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Element>
              <Element name="viewingyourtransactionhistory">
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Viewing Your Transaction History
                  </Accordion.Header>
                  <Accordion.Body>
                    <p className="accpara">
                      The transaction history in the tomi app allows you to
                      track all your crypto activities, including sent,
                      received, and failed transactions. You can also view
                      detailed information about each transaction, such as fees,
                      dates, and blockchain confirmations. To view your
                      transaction history in the tomi app, follow these steps:
                    </p>
                    <ol>
                      <li>
                        On the app home screen, tap the <strong>Wallet</strong>{" "}
                        icon at the bottom of the screen to open your wallet.
                      </li>
                      <li>
                        In the wallet screen, tap the{" "}
                        <strong>Transaction History</strong> icon in the
                        top-right corner.
                      </li>
                      <li>
                        A list of your recent transactions will appear, showing
                        details such as:
                      </li>
                      <ul>
                        <li>
                          The type of transaction (e.g., sent, received,
                          failed). You can also see if the transaction was
                          executed through the Chat or not.
                        </li>
                        <li>The cryptocurrency involved.</li>
                        <li>The amount and its equivalent value in USD.</li>
                        <li>The date of each transaction.</li>
                      </ul>
                      <li>
                        To view more details about a specific transaction, tap
                        on it. The <strong>Transaction Details</strong> screen
                        will display:
                      </li>
                      <ul>
                        <li>The sender and recipient information.</li>
                        <li>The transaction amount and associated fee.</li>
                        <li>The date and time of the transaction.</li>
                        <li>
                          A status indicator (e.g., Sent via Chat, Failed,
                          etc.).
                        </li>
                      </ul>
                      <li>
                        If applicable, you can tap{" "}
                        <strong>View on Etherscan</strong> (or the relevant
                        blockchain explorer) to see additional details about the
                        transaction on the blockchain.
                      </li>
                    </ol>
                  </Accordion.Body>
                </Accordion.Item>
              </Element>
            </Accordion>
          </div>
          <div className="bottom-btns">
            <NavLink
              exact
              to="/support/gettingstarted"
              className="innerbtn firstbtn"
            >
              <div className="leftbtn">
                <p className="innerbtnpara">fundamental - Previous</p>
                <p className="innerbtnhead">Getting started</p>
              </div>
              <span className="arrowmain">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.06049 4.55397L9.37832 4.23613L8.74265 3.60046L8.42482 3.9183L5.05367 7.28944L4.73584 7.60728L5.05367 7.92511L5.34095 8.21239L6.34791 7.26654L9.06049 4.55397ZM6.26778 7.86788L6.02193 8.89337L8.42482 11.2963L8.74265 11.6141L9.37832 10.9784L9.06049 10.6606L6.26778 7.86788Z"
                    fill="#0E1120"
                  />
                </svg>
              </span>
            </NavLink>
          </div>
        </div>
        <div className="right-sidebar">
          <div className="main-heading">
            <span>On this page</span>
          </div>
          <div className="rightlinks">
            <Link
              to="sendcryptoviachat"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Send crypto via Chat
            </Link>
            <Link
              to="requestpaymentsinchat"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Request payments in Chat
            </Link>
            <Link
              to="receivepaymentsinchat"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Receive payments in Chat (without a request)
            </Link>
            <Link
              to="viewingyourtransactionhistory"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Viewing Your Transaction History
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Chatandpayment;
